/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Participationreason_Label1Inputs */

const en_company_registration_participationreason_label1 = /** @type {(inputs: Company_Registration_Participationreason_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do you want to participate in the Matching Week?`)
};

const de_company_registration_participationreason_label1 = /** @type {(inputs: Company_Registration_Participationreason_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum möchten Sie an der Matching Week teilnehmen?`)
};

/**
* | output |
* | --- |
* | "Why do you want to participate in the Matching Week?" |
*
* @param {Company_Registration_Participationreason_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_registration_participationreason_label1 = /** @type {((inputs?: Company_Registration_Participationreason_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Participationreason_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_participationreason_label1(inputs)
	return en_company_registration_participationreason_label1(inputs)
});
export { company_registration_participationreason_label1 as "company_registration_participationReason_label" }